



































import { Vue, Component } from 'vue-property-decorator'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { User } from './interfaces/user'
import { unexpectedExc } from './utils'
import { assertErrCode, status } from './utils/status-codes'
import { noAuthenRoutes } from './router'

@Component({
  components: {
    LayoutDefault
  },
  computed: {
    ...mapGetters('account', {
      user: 'loggedInUser'
    }),
    ...mapState('message', {
      messageShow: 'show',
      messageText: 'text',
      messageColor: 'color'
    })
  },
  methods: {
    ...mapMutations('message', {
      showMessage: 'SHOW_MESSAGE',
      hideMessage: 'HIDE_MESSAGE'
    })
  }
})
export default class App extends Vue {
  /**
   * Init
   */
  user!: User
  loading = false
  initDone = false

  created (): void {
    this.setUserInfo()
  }

  setUserInfo (): void {
    const routeName = this.$route.name
    if (noAuthenRoutes.includes(routeName as string)) {
      this.initDone = true
      return
    }

    this.loading = true
    this.$store.dispatch('account/getInfo')
      .catch(err => {
        if (assertErrCode(err, status.HTTP_401_UNAUTHORIZED)) {
          this.$router.push({ name: 'Login' })
        } else {
          unexpectedExc(err)
        }
      })
      .finally(() => {
        this.loading = false
        this.initDone = true
      })
  }

  /**
   * Layout
   */

  get layout (): typeof Vue {
    const meta = this.$route.meta

    if (meta !== undefined) {
      if (this.user !== undefined) {
        if (
          this.user.user_type === 'teacher' &&
          meta.teacherLayout !== undefined
        ) {
          return meta.teacherLayout
        } else if (
          this.user.user_type === 'student' &&
          meta.studentLayout !== undefined
        ) {
          return meta.studentLayout
        }
      }

      if (meta.layout !== undefined) {
        return meta.layout
      }
    }

    return LayoutDefault
  }

  /**
   * Message
   */
  messageShow!: boolean
  messageText!: string
  messageColor!: string
  showMessage!: CallableFunction
  hideMessage!: CallableFunction

  setMessage (show: boolean): void {
    if (show) {
      this.showMessage()
    } else {
      this.hideMessage()
    }
  }
}
